import { render, staticRenderFns } from "./GroupMembersMain.vue?vue&type=template&id=7218a32d&"
import script from "./GroupMembersMain.vue?vue&type=script&lang=js&"
export * from "./GroupMembersMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports